import { render, staticRenderFns } from "./Analise.vue?vue&type=template&id=661e421c&scoped=true&"
import script from "./Analise.vue?vue&type=script&lang=js&"
export * from "./Analise.vue?vue&type=script&lang=js&"
import style0 from "./Analise.vue?vue&type=style&index=0&id=661e421c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661e421c",
  null
  
)

export default component.exports